"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackView = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const styles_1 = require("../View/styles");
const types_1 = require("./types");
const ALIGNS_VALUES = {
    [types_1.STACK_ALIGN.start]: 'flex-start',
    [types_1.STACK_ALIGN.center]: 'center',
    [types_1.STACK_ALIGN.end]: 'flex-end',
    [types_1.STACK_ALIGN.fill]: 'stretch'
};
const DISTRIBUTION_VALUES = {
    [types_1.STACK_DISTRIBUTION.fill]: '',
    [types_1.STACK_DISTRIBUTION.lastFill]: '',
    [types_1.STACK_DISTRIBUTION.firstFill]: '',
    [types_1.STACK_DISTRIBUTION.between]: 'space-between;',
    [types_1.STACK_DISTRIBUTION.center]: 'center',
    [types_1.STACK_DISTRIBUTION.around]: 'space-around',
    [types_1.STACK_DISTRIBUTION.start]: 'flex-start',
    [types_1.STACK_DISTRIBUTION.end]: 'flex-end'
};
const GAP_DIRECTION_PREFIX_VALUES = {
    column: 'top',
    row: 'left'
};
const gapStyles = ({ direction, gap, theme }) => gap &&
    (0, styled_components_1.css) `
        & > *:nth-child(n + 2) {
            margin-${GAP_DIRECTION_PREFIX_VALUES[direction]}: ${theme.spacing[gap || types_1.STACK_GAP.none]};
        }
`;
const Wrapper = (0, styled_components_1.default)(react_1.default.forwardRef((_a, ref) => {
    var { asTag, children } = _a, rest = __rest(_a, ["asTag", "children"]);
    return react_1.default.createElement(asTag || 'div', (0, helpers_1.clearProps)(rest, { ref }), children);
})) `
    ${styles_1.base};
    flex-wrap: nowrap;
    flex-direction: ${({ direction }) => direction};
    align-items: ${({ align }) => align && ALIGNS_VALUES[align]};
    justify-content: ${({ distribution }) => distribution ? DISTRIBUTION_VALUES[distribution] : 'flex-start'};

    ${gapStyles};

    ${({ distribution }) => distribution === types_1.STACK_DISTRIBUTION.fill &&
    (0, styled_components_1.css) `
            & > * {
                flex: 1 1 100%;
            }
        `};

    ${({ distribution }) => distribution === types_1.STACK_DISTRIBUTION.lastFill &&
    (0, styled_components_1.css) `
            & > *:last-child {
                flex: 1 1 100%;
            }
        `};

    ${({ distribution }) => distribution === types_1.STACK_DISTRIBUTION.firstFill &&
    (0, styled_components_1.css) `
            & > *:first-child {
                flex: 1 1 100%;
            }
        `};

    ${styles_1.background}
    ${styles_1.spacing};
    ${styles_1.borders};
    ${styles_1.clipped};
    ${styles_1.scroll};
    ${styles_1.root};
    ${styles_1.spaceFill};
    ${styles_1.size};
`;
exports.StackView = (0, helpers_1.createUIElement)('StackView', (_a, ref) => {
    var { className, asTag = 'div', direction = types_1.STACK_DIRECTION.row, testId, onFocus, onBlur, onDrag, onDragEnd, onDragEnter, onDragExit, onDragLeave, onDragOver, onDragStart, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "asTag", "direction", "testId", "onFocus", "onBlur", "onDrag", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || testId, className: `vm-StackView ${className}`, asTag: asTag, direction: direction, onFocus: onFocus, onBlur: onBlur, onDrag: onDrag, onDragEnd: onDragEnd, onDragEnter: onDragEnter, onDragExit: onDragExit, onDragLeave: onDragLeave, onDragOver: onDragOver, onDragStart: onDragStart, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
//# sourceMappingURL=StackView.js.map